"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('helpers/accessTokenHelper',["require", "exports", "jquery", "store/tokenStore", "services/tokenService"], function (require, exports, jquery, tokenStore, tokenService) {
    "use strict";

    var AccessTokeHelper = function AccessTokeHelper() {
        _classCallCheck(this, AccessTokeHelper);

        this.setRefreshTimeout = function () {
            if (tokenStore.getRefreshToken() && tokenStore.getAccessTokenExpiresIn() !== null) {
                var accessTokenRefreshTimeout = (tokenStore.getAccessTokenExpiresIn() - 60) * 1000;
                // Don't go below zero or above six hours to avoid numeric overflow (in IE8).
                var msMinute = 60000;
                var msHour = 60 * msMinute;
                var maxTimeout = 6 * msHour;
                var timeout = Math.min(Math.max(accessTokenRefreshTimeout, 0), maxTimeout);
                this.timeoutId = setTimeout(this.refreshAccessToken.bind(this), timeout);
            }
        };
        this.refreshAccessToken = function () {
            if (this.refreshDeferred !== null) {
                return this.refreshDeferred.promise();
            }
            this.refreshDeferred = jquery.Deferred();
            if (tokenStore.getRefreshToken()) {
                var result = tokenService.refreshToken();
                result.done(this.accessTokenApiCallSuccessful.bind(this)).fail(this.accessTokenApiCallFailed.bind(this)).always(this.accessTokenApiCallAlways.bind(this));
            } else {
                setTimeout(function () {
                    this.refreshDeferred.promise().always(this.accessTokenApiCallAlways.bind(this));
                    this.refreshDeferred.reject();
                }.bind(this), 0);
            }
            return this.refreshDeferred.promise();
        };
        this.accessTokenApiCallSuccessful = function (result) {
            this.refreshAccessTokenDone(result);
            this.refreshDeferred.resolve(result);
        };
        this.accessTokenApiCallFailed = function (result) {
            this.refreshDeferred.reject(result);
        };
        this.accessTokenApiCallAlways = function () {
            this.refreshDeferred = null;
            if (this.timeoutId) {
                clearTimeout(this.timeoutId);
            }
            this.setRefreshTimeout();
        };
        this.refreshAccessTokenDone = function (result) {
            tokenStore.setAccessToken(result.accessToken, result.refreshToken, result.accessTokenExpiresIn);
        };
        this.refreshDeferred = null;
    };

    return new AccessTokeHelper();
});
//# sourceMappingURL=accessTokenHelper.js.map;
